import { environment } from '../environments/environment';
import { CategoriasGoogleAnalytics, SesionService } from './services/sesion.service';
import { appInjector, getAppInjector } from './app-injector';
import { OnInit, OnDestroy, Directive } from '@angular/core';
import { Subscription } from 'rxjs';




@Directive()
export abstract class BaseComponent implements OnInit, OnDestroy {

  directoryImages: string;

  categoriasGoogleAnalytics = CategoriasGoogleAnalytics;


  protected _sesion: SesionService;
  get sesion(): SesionService {
    return this._sesion;
  }

  private subscriptiones = new Array<Subscription>();
  constructor() {
    this.directoryImages = environment.directoryImages;
    const injector = getAppInjector();
    this._sesion = injector.get(SesionService);

  }
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {

  }

  private destroyed = false;
  ngOnDestroy(): void {
    this.destroyed = true;
    this.subscriptiones.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
  protected addSubscription(subscription: Subscription) {
    this.subscriptiones.push(subscription);
  }
}
